'use client';

import React, { useEffect, useState } from 'react';

import { isSSR } from '@/utility/isSSR';

import PrivacyChoicesSvg from './icons/privacyoptions.svg';

/**
 * Client-side only component that renders the CCPA "Your Privacy Choices" icon
 * Only displays when the OneTrust script has been loaded
 */
export const PrivacyChoices: React.FC = () => {
  const [isOneTrustLoaded, setIsOneTrustLoaded] = useState(false);

  useEffect(() => {
    // Skip if running on server
    if (isSSR()) return;

    // Check if OneTrust is already loaded
    const checkOneTrust = () => {
      if (typeof window !== 'undefined' && (window as any).OneTrust) {
        setIsOneTrustLoaded(true);
        return true;
      }
      return false;
    };

    // Check immediately
    if (checkOneTrust()) return;

    // If not loaded yet, poll for OneTrust with a timeout
    let attempts = 0;
    const maxAttempts = 20; // Poll for up to 2 seconds
    const interval = setInterval(() => {
      attempts++;
      if (checkOneTrust() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  // Don't render anything on server or if OneTrust isn't loaded
  if (isSSR() || !isOneTrustLoaded) {
    return null;
  }

  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).OneTrust) {
      (window as any).OneTrust.ToggleInfoDisplay();
    }
  };

  return (
    <>
      {' '}
      |{' '}
      <button
        onClick={handleClick}
        className="inline-flex items-center cursor-pointer gap-1 hover:underline underline-offset-2"
        type="button"
        aria-label="Open Privacy Preferences">
        <PrivacyChoicesSvg
          className="inline-block"
          style={{ width: '30px', height: '14px', verticalAlign: 'middle' }}
          aria-hidden="true"
        />
        <span>Your Privacy Choices</span>
      </button>
    </>
  );
};
